import { isEmpty } from 'lodash-es';
import { formatAsUriParameters } from '@namespace/helpers';

const getIosLink = (
  link: string | null | undefined,
  params: Record<string, unknown>
): string | null | undefined => {
  if (!isEmpty(params) && link) {
    let iosUrl: URL | string;
    try {
      iosUrl = new URL(link);
    } catch {
      iosUrl = link;
    }

    const iosLink = iosUrl instanceof URL ? iosUrl.href : iosUrl;
    return `${iosLink}${
      iosUrl instanceof URL && iosUrl.search ? '&' : '?'
    }${formatAsUriParameters(params)}`;
  }

  return link;
};

export default getIosLink;
